import React, { useEffect, useRef } from "react";
import {
  ProjectContainer,
  ProjectLine,
  ProjectStep,
  StepCircle,
  StepButton,
  StepDescription,
} from "./styles";

const guestProjects = [
  { key: "math", label: "Math Note", desc: "Enter the mathematics notes platform." },
  { key: "tutor", label: "Tutor", desc: "View tutoring introduction and course process." },
  { key: "music", label: "Music Album", desc: "Explore music creation and albums." },
  { key: "algo", label: "Algorithm / Coding Note", desc: "Record algorithm studies and programming insights." },
  { key: "ai", label: "AI ChatBox", desc: "Start a conversation with the AI assistant." },
  { key: "about", label: "About Me", desc: "Get to know Sunny Tseng." },
];

const GuestMenu = ({ selected, onSelect }) => {
  const stepRefs = useRef([]);

  useEffect(() => {
    const handleScroll = () => {
      stepRefs.current.forEach((ref) => {
        if (!ref) return;
        const rect = ref.getBoundingClientRect();
        const inView = rect.top < window.innerHeight * 0.8 && rect.bottom > 0;
        if (inView) ref.classList.add("in-view");
        else ref.classList.remove("in-view");
      });
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <ProjectContainer>
      <ProjectLine />
      {guestProjects.map((item, index) => (
        <ProjectStep
          key={item.key}
          ref={(el) => (stepRefs.current[index] = el)}
          $isLeft={index % 2 === 0}
        >
          {index % 2 === 0 ? (
            <>
              <StepButton
                onClick={() => onSelect(item.key)}
                $isActive={selected === item.key}
              >
                {item.label}
              </StepButton>
              <StepCircle>{index + 1}</StepCircle>
              <StepDescription>
                {/* <h3>Project {index + 1}</h3> */}
                <h3>Info</h3>
                <p>{item.desc}</p>
              </StepDescription>
            </>
          ) : (
            <>
              <StepDescription>
                {/* <h3>Project {index + 1}</h3> */}
                <h3>Info</h3>
                <p>{item.desc}</p>
              </StepDescription>
              <StepCircle>{index + 1}</StepCircle>
              <StepButton
                onClick={() => onSelect(item.key)}
                $isActive={selected === item.key}
              >
                {item.label}
              </StepButton>
            </>
          )}
        </ProjectStep>
      ))}
    </ProjectContainer>
  );
};

export default GuestMenu;

